import Alpine from 'alpinejs';

// Components

// Global
window.Alpine = Alpine;

// Inits
Alpine.start();